"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextManagerMethod = exports.CustomerContextKey = void 0;
// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
exports.CustomerContextKey = {
    userContext: 'userContext',
    globalContext: 'globalContext',
    accountContext: 'accountContext',
};
// Use a const instead of const enum to avoid inlining the enum values in the bundle and save bytes
exports.ContextManagerMethod = {
    getContext: 'getContext',
    setContext: 'setContext',
    setContextProperty: 'setContextProperty',
    removeContextProperty: 'removeContextProperty',
    clearContext: 'clearContext',
};
//# sourceMappingURL=contextConstants.js.map